import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (window.ReactNativeWebView) {
      this.element.classList.add("d-none")
    }
  }
}
